import { atom } from 'jotai';


const userAtom = atom({});

export { userAtom };